export const STEP = {
  SET_CURRENT: 'upd/STEP_SET_CURRENT',
  IS_TERMINAL_ROUTE: 'upd/STEP_IS_TERMINAL_ROUTE',
  CLEAR_CURRENT: 'upd/STEP_CLEAR_CURRENT',
  GO_TO_NEXT: 'upd/STEP_GO_TO_NEXT',
  UPDATE: 'upd/STEP_UPDATE_STATE',
  SET_PERSONALIZED_STEPS: 'upd/STEP_SET_PERSONALIZED_STEPS',
};

export const setCurrent = current => ({
  type: STEP.SET_CURRENT,
  payload: { current },
});

export const clearCurrent = () => ({
  type: STEP.CLEAR_CURRENT,
  payload: {},
});

export const isTerminalRoute = (isTerminalRoute = true) => ({
  type: STEP.IS_TERMINAL_ROUTE,
  payload: {
    isTerminalRoute,
  },
});

export const goToNext = nextStep => ({
  type: STEP.GO_TO_NEXT,
  payload: {
    nextStep,
  },
});

export const setPersonalizedSteps = chosenSteps => ({
  type: STEP.SET_PERSONALIZED_STEPS,
  payload: {
    chosenSteps,
  },
});
